import { api } from '@services';

import Manufacturer, {
  IManufacturer,
  IManufacturerApiModel,
} from '@models/Manufacturer.model';

const getManufacturers = async (): Promise<IManufacturer[]> => {
  const { data: manufacturers } = await api.get<IManufacturerApiModel[]>(
    '/manufacturers',
  );

  return Manufacturer.arrayFromApiModel(manufacturers);
};

export { getManufacturers };
